<template>
    <div class="billing-address-form">
        <div class="container">
            <div class="header">
                <div class="title">Fatura Adresi</div>
            </div>
            <div class="form">
                <div class="column" v-if="form.isCompany">
                    <Input placeHolder="John" v-model="form.name" :title="'Şirket Adı'" />
                </div>
                <div class="column" v-else>
                    <Input placeHolder="John" v-model="form.name" :title="'Adı'" />
                    <Input placeHolder="Doe" v-model="form.surname" :title="'Soyadı'" />
                </div>
                <div class="column">
                    <Input
                        v-if="!form.isCompany"
                        placeHolder="00000000000"
                        v-model="form.idenity"
                        :title="'TC Kimlik'"
                    />
                    <Input placeHolder="johndoe@supsis.com" v-model="form.mail" :title="'E-Posta'" />
                </div>
                <div class="column" v-if="form.isCompany">
                    <div id="input">
                        <div class="title">
                            <label>Vergi Dairesi</label>
                        </div>
                        <a-auto-complete
                            v-model="form.taxOffice"
                            :data-source="taxOffices"
                            style="width: 100%"
                            @search="onSearch"
                        />
                    </div>
                    <Input placeHolder="00000000000" v-model="form.taxNumber" :title="'Vergi Numarası'" />
                </div>
                <div class="column">
                    <Input placeHolder="Türkiye" v-model="form.country" :title="'Ülke'" />
                    <Input placeHolder="İstanbul" v-model="form.city" :title="'Şehir'" />
                </div>
                <Input placeHolder="TeknoPark" v-model="form.address" :title="'Adress'" />
                <div class="billing-addreses-type">
                    <input type="checkbox" v-model="form.isCompany" />
                    <label>Şirket Faturası olarak kayıt et</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Input from "../../Input.vue";
import { mapState } from "vuex";
import TaxOffices from "../../../utils/taxOffices";

export default {
    name: "BillingAddressForm",
    data() {
        return {
            taxOffices: [],
            form: {
                name: null,
                surname: null,
                idenity: null,
                mail: null,
                country: null,
                city: null,
                address: null,
                taxNumber: null,
                isCompany: false,
                taxOffice: null,
            },
        };
    },
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
        }),
    },
    mounted() {
        this.form = {
            name: this.billingDetail?.name,
            surname: this.billingDetail?.surname,
            idenity: this.billingDetail?.identityNumber,
            mail: this.billingDetail?.email,
            country: this.billingDetail?.billingCountry,
            city: this.billingDetail?.billingCity,
            address: this.billingDetail?.billingAddress,
            isCompany: this.billingDetail?.billingType === "company",
            taxNumber: this.billingDetail?.taxNumber,
            taxOffice: this.billingDetail?.taxOffice,
        };
    },
    methods: {
        onSearch(searchText) {
            this.taxOffices =
                !searchText || searchText.length < 2
                    ? TaxOffices.slice(0, 5)
                    : TaxOffices.filter((s) => s.toUpperCase().includes(searchText.toUpperCase()));
        },
    },
    watch: {
        form: {
            handler() {
                this.$emit("input", this.form);
            },
            deep: true,
        },
    },
    components: { Input },
};
</script>
<style lang="scss">
.billing-address-form {
    width: 100%;

    .container {
        padding: 36px 36px;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 10px;
        background-color: white;

        .header {
            margin-bottom: 24px;

            .title {
                font-size: 24px;
                color: #144167;
                font-weight: bold;
                margin-bottom: 15px;
            }
        }
    }

    .form {
        .column {
            display: flex;
            justify-content: center;
            align-items: center;

            :first-child {
                margin-right: 10px;
            }
        }

        .billing-addreses-type {
            display: flex;
            align-items: center;
            gap: 10px;
            input {
                accent-color: #ec4b1d;
                width: 20px;
                height: 20px;
            }
            label {
                margin: 0;
            }
        }
    }

    #input {
        margin-bottom: 10px;

        .title label {
            font-size: 14px !important;
            font-weight: bold;
        }

        .input-container {
            padding: 10px 5px !important;
            height: auto !important;

            input {
                font-size: 14px !important;
            }
        }
    }
}
</style>
